import { jwtDecode } from "jwt-decode"

export function isTokenExpired(token) {
  try {
    const { exp } = jwtDecode(token)
    return exp < Date.now() / 1000
  } catch (e) {
    return true
  }
}

export function logoutAndRedirect() {
  localStorage.setItem("sessionExpired", "true") // 👈 Guardamos que fue por expiración
  const tmp = localStorage.getItem("sessionExpired") // Para conservarlo tras el clear()
  localStorage.clear()
  if (tmp) localStorage.setItem("sessionExpired", tmp)
  window.location.href = "/login"
}
